<template>
  <div class="bg-gray p-2">
    <div class="bg-white p-3">
      <div class="row">
        <div class="col-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Información Adicional</span>
        </div>
        <div class="col-12 col-md-5">
          <span class="font-14 font-weight-normal color-secondary-6">
            Estudiante:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.studentSieId }} - {{ value.studentFullName }}
          </p>
        </div>
        <div class="col-6 col-md-3">
          <span class="font-14 font-weight-normal color-secondary-6">
            Tipo de Servicio:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.discipline }}
          </p>
        </div>
        <div class="col-6 col-md-3">
          <span class="font-14 font-weight-normal color-secondary-6">
            Proveedor:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.provider }}
          </p>
        </div>
        <div class="col-12">
          <span class="font-14 font-weight-normal color-secondary-6">
            Comentario:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ value.comment }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalInfo',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@media only screen and (max-width: 768px) {
  span,
  p {
    font-size: map-get($fontsSize, 'font-12') !important;
  }
}
</style>
